<script setup lang="ts">
  const userStore = useUserStore();
  const route = useRoute();

  const jobId = route.params.jobId?.toString();
  const jobSlug = route.params.slug?.toString();
  const jobApplicationSource = route.query.source?.toString();
  const jobApplicationType: 'external' | 'direct_link' =
    route.query.applicationType === 'external' || route.query.applicationType === 'direct_link'
      ? route.query.applicationType
      : 'external';

  onBeforeMount(navigate);

  function navigate() {
    navigateToExternalJobApplication(
      jobId,
      jobSlug,
      userStore.isAuthenticated,
      {
        source: jobApplicationSource,
        applicationType: jobApplicationType,
      },
      { open: { target: '_self' } },
    );
  }
</script>
